import React, { useEffect, useState, Fragment, useCallback } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { setGoHome } from "../../action/homeAction";
import SubEventCard from "./SubEventCard";
import { makeStringStrictlyCapitalize } from "../../JS/utility";


const WayActivity3 = (props) => {
  const { goNextPage, goPreviousPage, eventDetailedInfo, selectedData, handleSelectedDataChange, t} = props;

  const [subEvents, setSubEvents] = useState(null);

  const findSelectedEventsSubEvents = useCallback( () => {  
      return eventDetailedInfo.resourceGroups
  },[]);



  const handleSubEventClick = (subEvent) => {
    goNextPage({type:"SUB_EVENT_SELECTED", payload:{subEvent}});
    handleSelectedDataChange({
      subEvent
    })
  }



  useEffect(() => {
    const subevents_ = findSelectedEventsSubEvents();

    if(subevents_ && subevents_.length > 0) setSubEvents(subevents_)
    else handleSubEventClick(null)
  }, [])

  return (
    <>
    <header className="inner-pages w-footer subpages">
                    <a className="button-back" onClick={props.goPreviousPage}></a>
                    <div className="heading align-center">
                    <div class="header">
                        <p className="text">{t("way_activity.common.header_text")}</p>
                     
                    </div>
                    </div>
     </header>
    <section id="activitiespage3" class="widgets activity-listing activity-subevent-listing" style={{ color: 'black' }}>
      <div className="header">
        <div>
          <div className="widget-header-title" >{makeStringStrictlyCapitalize(String(selectedData.event.title))}</div>
          {/* <p className="widget-header-subtitle" >{selectedData.event.headline}</p> */}
        </div>
      
      </div>

        {
          subEvents &&
          
          <div  class="events-container">
          <div className="text-bold" > {t("way_activity.event_details_page_content.select_sub_event")} </div>

            {
              subEvents.map((subEvent_) => {
                return (
                  <div key={subEvent_.id}
                    onClick={() => {
                        handleSubEventClick(subEvent_)
                    }}
                  >
                    <SubEventCard
                      imageSrc={subEvent_.pictures && subEvent_.pictures[0] && subEvent_.pictures[0].uri && subEvent_.pictures[0].uri.original }
                      title={subEvent_.title}
                      subtitle={subEvent_.description}
                    />
                  </div>
                )
              })
            }
        </div>
        }        
    </section>



    </>
  )
}


const mapStateToProps = (state) => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
    menuColor: state.store.home.MenuColor,

  };
};

export default connect(mapStateToProps,
  {  })(
    withTranslation("translations")(WayActivity3)
  );



export function CalenderSvg (){
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M17.5 8.33329H2.5M13.3333 1.66663V4.99996M6.66667 1.66663V4.99996M6.5 18.3333H13.5C14.9001 18.3333 15.6002 18.3333 16.135 18.0608C16.6054 17.8211 16.9878 17.4387 17.2275 16.9683C17.5 16.4335 17.5 15.7334 17.5 14.3333V7.33329C17.5 5.93316 17.5 5.2331 17.2275 4.69832C16.9878 4.22791 16.6054 3.84546 16.135 3.60578C15.6002 3.33329 14.9001 3.33329 13.5 3.33329H6.5C5.09987 3.33329 4.3998 3.33329 3.86502 3.60578C3.39462 3.84546 3.01217 4.22791 2.77248 4.69832C2.5 5.2331 2.5 5.93316 2.5 7.33329V14.3333C2.5 15.7334 2.5 16.4335 2.77248 16.9683C3.01217 17.4387 3.39462 17.8211 3.86502 18.0608C4.3998 18.3333 5.09987 18.3333 6.5 18.3333Z" stroke="black" stroke-width="1.25" stroke-linecap="square" stroke-linejoin="round"/>
  </svg>
}